var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWomanHairstyle5A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Woman_x5F_hair:"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x35_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x35_a_6_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#862618",
    d: "M436.3,107.8c10.9-0.1,21.8,1.5,32.3,4.1c-2.9-4.3-6.2-8.3-9.7-12c-0.7-0.7-1.3-1.4-2-2.1 c-32.2-33.8-94.8-36.6-125.5-0.1l0,0c-1.1-0.3-2.1-0.5-3.2-0.7c-26.2-5.5-53.2,3.2-73.6,20.2c-4.6,3.8-8.9,8.1-12.7,12.6 c-26.4,28-27.5,73.7-7.8,105.9c3.9,6.5,8.5,12.4,14,17.7c5.4,5.3,11.7,9.8,18.7,13.3c0-1.6,0-3.2,0-4.8 c0.7-28.9,10.4-70.3,43-84.2c1.5-0.6,3.1-1.2,4.7-1.8c-3.2,4.5-8.8,11.3-14.3,12.4c11.9,2.7,32.8-4.1,41.7-14 c16.9,28.9,44.9,40.8,63,44c-0.4-1-0.8-2.1-1.1-3.1c-4.3-12.5-5.2-25.6-4.7-37.7c13.6,15.6,24.8,33.1,30.6,53.1 c0.7-4.3,1.2-8.7,1.4-13.1c0.4-8.4-0.2-16.9-1.9-25.2c15.9,45,5.8,97.3-20.5,137c6.1-1.3,11.9-3.2,17.3-5.7 c1.6-0.8,3.3-1.6,4.8-2.4c9.9-5.4,18.5-12.8,25.7-21.5c5-6.3,9.2-13.1,12.6-20.1c0.2,8.1-1.4,14.4-3.6,21 c6.7-4.6,12.9-10.2,18.3-16.7c14.1-16.8,23-36,16.6-62.1c4.5,5,7.6,10.7,9.8,16.7c0.2-1,0.3-2,0.5-3 C516.1,184.7,492.1,115.1,436.3,107.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#A94E3C",
    d: "M255.2,196.4c-1.6,9.1-1.9,18-0.7,25.9c2.5-24,16.1-46.8,34.3-62.3c11.6-9.5,26.4-14.8,41.2-16.6 c-0.4-1.7-0.7-3.5-1-5.3C294.6,138.1,266,164.9,255.2,196.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A94E3C",
    d: "M406.4,88.8c-13.9-1.3-26.8-2.7-41,2.8c-12.1,5-20,14-25.5,24.8c9.8-11.5,18.7-18.1,29.7-22.4 C382.6,89.2,391.7,89.2,406.4,88.8L406.4,88.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A94E3C",
    d: "M475.7,148.1c-13.3-14.7-28.1-24.1-46.6-28c17.4,6.7,31.1,16.7,43.5,30.7c13.9,16.7,21.7,33.3,29.4,54.2 l0,0C498.2,183.9,490.5,165.6,475.7,148.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M247.3,164.2c-16.2,16.2-17.1,46.9-13.7,70.6c0.2,0.3,0.3,0.6,0.5,0.9c3.4,5.8,7.5,11.2,12.3,16 C238.2,229.2,232.5,185.4,247.3,164.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M266.7,262c0.7-28.9,10.4-70.3,43-84.2C275.4,183.5,253.8,228.5,266.7,262z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M468.6,111.9c-2.9-4.3-6.2-8.3-9.7-12c-20.5,0.8-41.4,3-57.1,15.9c10.8-5.6,22.6-7.9,34.5-8.1 C447.2,107.6,458.2,109.3,468.6,111.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M331.4,97.7C331.4,97.7,331.3,97.7,331.4,97.7C331.3,97.7,331.4,97.7,331.4,97.7L331.4,97.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M254.4,222.2c-1.2-7.9-0.9-16.8,0.7-25.9c3.4-19.6,12.4-39.9,23.5-52.1c-29.2,26.1-39.7,70-24.6,114.5 c2.4,1.9,4.9,3.6,7.6,5.2C257.8,252.6,253.4,232.3,254.4,222.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M471.3,181c13.1,31.7,12.8,68.1-2.3,98.9c0.2,8.1-1.4,14.4-3.6,21c6.7-4.6,12.9-10.2,18.3-16.7 C495.7,249.8,490,212.5,471.3,181z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M331.4,97.7C331.4,97.7,331.3,97.7,331.4,97.7c-1.1-0.3-2.1-0.5-3.2-0.7c-1.6,15.5-1.1,29.1,0.8,41.1 c0.3,1.8,0.6,3.6,1,5.3c2.5,12.1,6.6,22.4,11.8,31.1c16.9,28.9,44.9,40.8,63,44c-0.4-1-0.8-2.1-1.1-3.1 C355.5,199.3,331.2,146.1,331.4,97.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M398.9,177.8c13.6,15.6,24.8,33.1,30.6,53.1c0.7-4.3,1.2-8.7,1.4-13.1c-15.1-35.7-43.9-63.9-77.8-82.3 C368.9,148.2,385.1,162,398.9,177.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E1003",
    d: "M429,192.6c15.9,45,5.8,97.3-20.5,137c6.1-1.3,11.9-3.2,17.3-5.7c0.4-0.8,0.9-1.6,1.3-2.4 c2.8-5.3,5.2-10.8,7.4-16.5c16.7-45.1,14-99.1-14.2-138.1C424.3,175,427.3,183.7,429,192.6z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanHairstyle5A);
export default __webpack_public_path__ + "static/media/woman_hairstyle_5a.3f147a6529085779a2a2928492d536ed.svg";
export { ForwardRef as ReactComponent };